import {
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Space,
  Typography
} from "antd";
import dayjs from 'dayjs';
import React, { useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
const { Title } = Typography;

const PatientInformation = ({ getChildData, patientDetailsFMLA }) => {
  const { t, i18n } = useTranslation();
  const dateFormat = "MM/DD/YYYY";
  const onChangeMethod = (e) => {
    callparent(e.target.value, "IsPatient");
  };
  
  const validatePhone = useCallback((_, value) => {
    const phoneRegex = /^[+]?[0-9]{10,15}$/;
    if (!value || phoneRegex.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error(t("common:please_enter_a_valid_phone_number")));
  }, [t]);
  
  const validationRules = useMemo(() => ({
    required: [{ required: true, message: t("patientDetailsFMLS:please_choose_any_option") }],
    select: [{ required: true, message: t("patientDetailsFMLS:please_select_an_option") }],
    firstName: [{ required: true, max: 50, message: t("patientDetailsFMLS:please_enter_first_name") }],
    lastName: [{ required: true, max: 50, message: t("patientDetailsFMLS:please_enter_last_name") }],
    dob: [{ required: true, message: t("patientDetailsFMLS:please_enter_date_of_birth") }],
    phone: [{ required: true, max: 20, message: t("patientDetailsFMLS:please_enter_phone_number") }, { validator: validatePhone }],
    email: [{ max: 100, message: t("patientDetailsFMLS:please_enter_email") }, { type: "email", message: t("patientDetailsFMLS:please_enter_valid_email") }],
    address: [{ required: true, max: 150, message: t("patientDetailsFMLS:please_enter_address") }],
    city: [{ required: true, max: 50, message: t("patientDetailsFMLS:please_enter_city_name") }],
    state: [{ required: true, message: t("patientDetailsFMLS:please_enter_state_name") }],
    zipCode: [{ max: 8, required: true, message: t("patientDetailsFMLS:please_enter_zip_code") }, { pattern: /^[0-9]+$/, message: t("patientDetailsFMLS:zip_code_must_be_numeric") }, { min: 5, message: t("patientDetailsFMLS:zip_code_must_be_at_least_5_digits_long") }]
  }), [t, validatePhone]);
  
  const callparent = (e, name) => {
    getChildData(e, name);
  };

  const disableFutureDates = (current) => {
    // Can not select days after today
    return current && current > dayjs().endOf('day');
  };
  return (
    <Card
      styles={{ body: { padding: 0 }, header: { marginBottom: 20 } }}
      bordered={false}
      size="0"
      title={
        <Title
          className="font-semibold"
          style={{ marginBottom: "0" }}
          level={4}
        >
          {t("patientDetailsFMLS:patient_information")}
        </Title>
      }
    >
      <Row gutter={[0, 0]} align={"bottom"} className="px-1 md:px-6">
        <Col>
          <Form.Item
            name="areupatient"
            label={t("patientDetailsFMLS:are_you_the_patient")}
            rules={validationRules.required}
          >
            <Radio.Group onChange={(e) => onChangeMethod(e)} value={patientDetailsFMLA.methodOfRelease} >
              <Space direction="vertical" className="ms-4"
              >
                <Radio value={"yes"} className="font-normal">
                  {t("patientDetailsFMLS:yes")}
                </Radio>
                <Radio value={"no"} className="font-normal">
                  {t("patientDetailsFMLS:no")}
                </Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
        </Col>
        {patientDetailsFMLA.IsPatient == "no" ? (
          <Col>
            <Form.Item
              labelCol={{ xl: 13 }}
              layout="horizontal"
              className="patient-form-item"
              name="associatedpatient"
              label={<label>{t("patientDetailsFMLS:how_are_you_associated_with_the_patient")}</label>}
              rules={validationRules.select}
            >
              <Select
                placeholder={t("patientDetailsFMLS:select_an_option")}
                size="large"
                className="!w-full md:!w-[250px]"
                // style={{
                //   width: 250,
                // }}
                name="AssociatedWithPatient"
                onChange={(e) => callparent(e, "AssociatedWithPatient")}
                options={[
                  {
                    value: "1",
                    label: t("patientDetailsFMLS:parent_legal_guardian"),
                  },
                  {
                    value: "2",
                    label: t("patientDetailsFMLS:authorized_representative"),
                  },
                  {
                    value: "3",
                    label: t("patientDetailsFMLS:third_party_insurance_employer"),
                  },
                ]}
              />
            </Form.Item>
          </Col>
        ) : null}
      </Row>
      {patientDetailsFMLA.IsPatient == "yes" || patientDetailsFMLA.IsPatient == "no" ? (
        <Row gutter={[20, 0]} className="px-1 md:px-6">
          <Col xs={24} md={12}>
            <Form.Item
              label={t("patientDetailsFMLS:patient_first_name")}
              name="firstname"
              onChange={(e) => callparent(e.target.value, "PFirstName")}
              required
              rules={validationRules.firstName}
            >
              <Input maxLength={50} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label={t("patientDetailsFMLS:patient_last_name")}
              name="lastname"
              onChange={(e) => callparent(e.target.value, "PLastName")}
              required
              rules={validationRules.lastName}

            >
              <Input maxLength={50} />
            </Form.Item>
          </Col>
          <Col xl={patientDetailsFMLA.IsPatient == "no" && patientDetailsFMLA.AssociatedWithPatient == 1 ? 6 : 8} xs={24} md={12}>
            <Form.Item
              name="dob"
              label={t("patientDetailsFMLS:date_of_birth")}
              required
              rules={validationRules.dob}
            >
              <DatePicker
                format={dateFormat}
                disabledDate={disableFutureDates}
                style={{ minWidth: "100%" }}
                name="PDOB"
                onChange={(e) => callparent(e, "PDOB")}
                placeholder={t("common:select_date")}
              />
            </Form.Item>
          </Col>
          {patientDetailsFMLA.IsPatient == "no" && patientDetailsFMLA.AssociatedWithPatient == 1 ?
            <Col xl={patientDetailsFMLA.IsPatient == "no" && patientDetailsFMLA.AssociatedWithPatient == 1 ? 4 : 8} xs={24} md={12}>
              <Form.Item
                name="IsPatientMinor"
                label={t("patientDetailsFMLS:is_the_patient_a_minor")}
                rules={validationRules.required}
              >

                <Radio.Group onChange={(e) => callparent(e.target.value, "IsPatientMinor")} value={patientDetailsFMLA.IsPatientMinor}>
                  <Radio value={"yes"} className="font-normal">
                    {t("patientDetailsFMLS:yes")}
                  </Radio>
                  <Radio value={"no"} className="font-normal">
                    {t("patientDetailsFMLS:no")}
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            : null}
          <Col xl={patientDetailsFMLA.IsPatient == "no" && patientDetailsFMLA.AssociatedWithPatient == 1 ? 8 : 8} xs={24} md={12}>
            <Form.Item
              label={t("patientDetailsFMLS:email")}
              name="email"
              onChange={(e) => callparent(e.target.value, "PEmail")}
              required
              rules={validationRules.email}
            >
              <Input maxLength={100} />
            </Form.Item>
          </Col>

          <Col xl={patientDetailsFMLA.IsPatient == "no" && patientDetailsFMLA.AssociatedWithPatient == 1 ? 6 : 8} xs={24} md={12}>
            <Form.Item
              className="font-medium"
              label={t("patientDetailsFMLS:phone_number")}
              required
              name="phone"
              onChange={(e) =>
                callparent(e.target.value, "PatientPhoneNumber")
              }
              rules={validationRules.phone}
            >
              <Input maxLength={20} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label={t("patientDetailsFMLS:address_line_1")}
              name="address1"
              onChange={(e) => callparent(e.target.value, "PAddLine1")}
              rules={validationRules.address}
            >
              <Input maxLength={150} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label={t("patientDetailsFMLS:address_line_2")}
              name="address2"
              onChange={(e) => callparent(e.target.value, "PAddLine2")}
            >
              <Input maxLength={150} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label={t("patientDetailsFMLS:city")}
              name="city"
              onChange={(e) => callparent(e.target.value, "PCity")}
              required
              rules={validationRules.city}
            >
              <Input maxLength={50} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label={t("patientDetailsFMLS:state")}
              name="state"
              onChange={(e) => callparent(e.target.value, "PState")}
              required
              rules={validationRules.state}
            >
              <Input maxLength={50} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label={t("patientDetailsFMLS:zip_code")}
              name="zipcode"
              onChange={(e) => callparent(e.target.value, "PZipCode")}
              required
              rules={validationRules.zipCode}
            >
              <Input maxLength={8} />
            </Form.Item>
          </Col>
        </Row>
      ) : null}
    </Card>
  );
};

export default PatientInformation;
